import { render, staticRenderFns } from "./AsociarEtiquetas.vue?vue&type=template&id=5cbafafb&"
import script from "./AsociarEtiquetas.vue?vue&type=script&lang=ts&"
export * from "./AsociarEtiquetas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports